module.exports = __webpack_public_path__ + "img/logo.fce57df1.png";